export default __webpack_public_path__ + "static/media/main-bg-item2.ebd85fb0.png";